module.exports = __webpack_public_path__ + "img/icon-edit-active.7fbf9c79.svg";